<template>
  <!--
    Navbar video guide. Renders nothing on pages that have no guide registered
    in `video-guides.constant.ts`, so the icon only appears where a video exists.
  -->
  <div v-if="guide">
    <SpotlightCallout
      storage-key="sms-video-guide-intro-seen"
      title="New: Page Guides"
      icon="pi pi-video"
    >
      <template #content>
        <div class="space-y-1.5">
          <p>Short <strong>walkthrough videos</strong> are now built into the pages that have them.</p>
          <p>Click the <i class="pi pi-video text-blue-500"></i> icon to watch a guide for the page you're on.</p>
          <p class="text-xs text-gray-400">The icon only shows up on pages with a guide available.</p>
        </div>
      </template>

      <Button
        icon="pi pi-video"
        text
        rounded
        class="!w-10 !h-10 text-gray-500 hover:bg-gray-100"
        :aria-label="guide.title"
        v-tooltip.bottom="guide.title"
        data-testid="btn-video-guide"
        @click="visible = true"
      />
    </SpotlightCallout>

    <Dialog
      v-model:visible="visible"
      modal
      :header="guide.title"
      :style="{ width: '800px', maxWidth: '95vw' }"
      :draggable="false"
    >
      <iframe
        v-if="visible"
        :src="guide.videoSrc"
        class="w-full rounded-lg"
        style="height: 400px"
        frameborder="0"
        allow="autoplay"
        allowfullscreen
      />
    </Dialog>
  </div>
</template>

<script setup lang="ts">
import SpotlightCallout from './SpotlightCallout.vue';
import { getVideoGuide } from '@/constants/video-guides.constant';

const route = useRoute();

const guide = computed(() => getVideoGuide(route.name));
const visible = ref(false);

// Close the player when navigating away — the dialog outlives the route change.
watch(() => route.name, () => {
  visible.value = false;
});
</script>
